"use strict";
import ApiService from "../services/api_service";
import fetch from "../util/fetch";
export default {
  // Get shipment status by Invoice ID
  get({ invoice_id }) {
    return ApiService.addErrorHandler(
      fetch(`/api/acertus_shipment_approval?invoice_id=${invoice_id}`, {
        method: "get"
      })
    );
  },
  // Update a specific shipment
  put({ invoice_id, shipment }) {
    return ApiService.addErrorHandler(
      fetch(`/api/acertus_shipment_approval/${shipment.id}`, {
        method: "put",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shipment, invoice_id })
      })
    );
  }
};
